import { render, staticRenderFns } from "./HeadToHead.vue?vue&type=template&id=61d30870&scoped=true"
import script from "./HeadToHead.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeadToHead.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeadToHead.vue?vue&type=style&index=0&id=61d30870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d30870",
  null
  
)

export default component.exports